export default __webpack_public_path__ + "static/media/Hand_left.ceb5b54f.svg";